import { getResource } from "services";
export function logoutUser(onSuccess, onFail) {
  const path = `api/v1/isActive`;
  getResource(path, onSuccess, onFail);
}
